import axios from "axios";
import { store } from "../store";
import url from "./base-url";
import browser from "./browser-check";
axios.defaults.timeout = 30000;
axios.defaults.baseURL = url.base;
axios.defaults.withCredentials = true;

// ========== 公司一致性检查（防止多窗口切换公司后旧窗口误操作） ==========
var COMPANY_CHECK_INTERVAL = 5000; // 5秒内复用缓存
var companyCheckPromise = null;
var lastCompanyCheckTime = 0;

/**
 * 请求 /api/Enterprise/Simple 比对后端当前公司与前端 curCompany
 * 不一致时跳转到切换公司等待页；5秒内复用缓存避免请求风暴
 */
function checkCompanyConsistency() {
  var now = Date.now();
  if (companyCheckPromise && now - lastCompanyCheckTime < COMPANY_CHECK_INTERVAL) {
    return companyCheckPromise;
  }

  lastCompanyCheckTime = now;
  companyCheckPromise = axios
    .get("/api/Enterprise/Simple")
    .then(function(res) {
      var serverCompanyId = res.data && res.data.id;
      var localCompanyId = store.state.curCompany && store.state.curCompany.id;
      if (
        serverCompanyId != null &&
        localCompanyId != null &&
        String(serverCompanyId) !== String(localCompanyId)
      ) {
        // 公司不一致，跳转到切换公司等待页
        window.location.replace("/switchingCompany?id=" + serverCompanyId);
        return false;
      }
      return true;
    })
    .catch(function() {
      // 检查失败不阻塞业务请求
      return true;
    });

  return companyCheckPromise;
}

/** 通用请求配置（IE 随机数 + 企联网标记） */
function applyCommonConfig(config) {
  if (browser.isIE() && config.method == "get") {
    if (config.url.indexOf("?") == -1) {
      config.url = config.url + "?random=" + Math.random();
    } else {
      config.url = config.url + "&random=" + Math.random();
    }
  }
  config.headers.isqlw = store.state.inQlw;
  return config;
}

// http request 拦截器
axios.interceptors.request.use(
  async function(config) {
    // 跳过公司检查接口自身，避免死循环
    if (config.url.indexOf("/api/Enterprise/Simple") !== -1) {
      return applyCommonConfig(config);
    }

    // 跳过登录、切换公司相关接口
    if (
      config.url.indexOf("/api/account/LoginUser") !== -1 ||
      config.url.indexOf("/api/Enterprise/ChangeEnterprise") !== -1
    ) {
      return applyCommonConfig(config);
    }

    // 未登录或 curCompany 未初始化时跳过检查
    if (!store.state.curCompany || store.state.curCompany.id == null) {
      return applyCommonConfig(config);
    }

    var ok = await checkCompanyConsistency();
    if (!ok) {
      // 已跳转切换公司页，阻止当前请求发出
      return new Promise(function() {});
    }

    return applyCommonConfig(config);
  },
  function(error) {
    return Promise.reject(error);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status == 401) {
      window.location.href = "/login";
    }
    if (error.response.status == 403) {
      if (store.state.inQlw) {
        window.location.href = "/403?appid=1";
      } else {
        window.location.href = "/403";
      }
    }
    return Promise.reject(error);
  }
);
export default axios;
